import { makeStyles } from 'tss-react/mui';

export const useVideoPreviewStyles = makeStyles()(() => ({
  video: {
    position: 'absolute',
    left: 0,
    top: 0,
    objectFit: 'cover',
  },
  paper: {
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
